var hasAcceptedStrictlyNecessary = function () {
    return ICF.Utils.Consent.CookieContainsPattern(ICF.Variables.ConsentGroupPatterns.AcceptedStrictlyNecessary)
};

module.exports = hasAcceptedStrictlyNecessary;